import { render, staticRenderFns } from "./SkillSet.vue?vue&type=template&id=878664f6&scoped=true"
import script from "./SkillSet.vue?vue&type=script&lang=ts"
export * from "./SkillSet.vue?vue&type=script&lang=ts"
import style0 from "./SkillSet.vue?vue&type=style&index=0&id=878664f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878664f6",
  null
  
)

export default component.exports